<template>
  <div class="title-page" :class="classTitle">
    <h4>{{ attrpage }}</h4>
    <h1><slot></slot></br><span>{{ baseline }}</span></h1>
  </div>
</template>

<script>
  export default {
    props: ['attrpage', 'baseline', 'classTitle']
  }
</script>

<style>
  .title-page h4 {
    font-size: 13px;
    color: #da1e52;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 15px;
   }
  .title-page h1 {
    font-size: 36px;
    color: #413492;
    letter-spacing: 1px;
    line-height: 34px;
    margin-bottom: 45px;
    margin-top: 0;
   }
  .title-page h1 span {
    font-family: 'blogger_sanslight';
    font-size: 24px;
  }
  .title-page.tiny h1 { display: none;}
  
</style>
